// import Firebase from './firebase';
import JWTAuth from './jwt';
// import BasicAuth from "./Basic";

export const AuthMethods = {
    // firebase: Firebase,
    jwtAuth: JWTAuth,
    // basic: BasicAuth
};
